// extracted by mini-css-extract-plugin
export default {"wrapper":"MultiImageUploader_wrapper__jXHHF"};